<template>
  <div>
    <a :class="className" @click.prevent="showModal" href="#">
      {{ deleteText }}
    </a>

    <div
      ref="modal"
      class="modal fade"
      id="confirmation"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="confirmationLabel">{{questionText | translate}}</h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-start">
            {{explanationText | translate}}
            <form
              ref="delete-form"
              :action="url"
              method="POST"
              style="display: none"
            >
              <input type="hidden" :value="csrf" name="_token" />
              <input type="hidden" name="_method" value="DELETE" />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              {{cancelText | translate}}
            </button>
            <button type="button" class="btn btn-danger btn-sm" @click="submitForm">{{deleteText | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'url',
    'csrf',
    'deleteText',
    'questionText',
    'explanationText',
    'cancelText',
    'className',
  ],
  data: () => ({
    modal: null
  }),
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal)
  },
  methods: {
    submitForm() {
      this.$refs['delete-form'].submit()
    },
    showModal() {
      this.modal.show()
    },
  },
}
</script>
